export default __webpack_public_path__ + "static/media/short stay EU Citizen.c4506449.jpg";